import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FileProvider } from '../file.provider';
import { UIService } from '../../ui.service';
import { I18N } from 'ess-plugin-base';

@Component({
    selector: 'file-download-progress',
    templateUrl: './file.download.progress.html',
    styleUrls: ['./file.download.progress.scss']
})
export class FileDownloadProgress {

    progress: number = 0;

    downloading: boolean;

    @Input('filename')
    filename: string;

    @Input('guid')
    guid: string;

    @Input('size')
    size: number;

    @Input('caption')
    caption: string;

    @Input('show-icon')
    showIcon: boolean;

    constructor(private fileProvider: FileProvider, private ui: UIService, private i18n: I18N) {}

    downloadFile() {
        if (!this.filename || !this.guid) return;

        let download = this.fileProvider.downloadProgress(this.filename, this.guid);
        this.progress = 0;
        this.downloading = true;

        download.progress.subscribe({
            next: (progress) => {
                this.progress = progress;
            },
            complete: () => {
                this.progress = 100;
                setTimeout(() => { this.downloading = null; }, 2000);

                this.fileProvider.writeContents(download.array, this.filename, 'application/octet-stream');
                // download.blob;
            },
            error: (err) => {
                this.progress = 0;
                setTimeout(() => { this.downloading = null; }, 2000);
                console.log(err);
                this.ui.error( this.i18n.get('file_download_error', 'File could not be downloaded.'));
            }
        })
        // this.fileProvider.download(file);   //{filename: msg.filename, guid: msg.guid});
    }

    getExtension(): string {
        if (this.filename && this.size > 0) {
            return this.filename.slice(this.filename.lastIndexOf('.') + 1);
        }
        if (!this.size) {
            return 'folder';
        }
        return null;
    }       
}